module.exports = __webpack_public_path__ + "static/img/ministry.bedc4559.png";